<template>
  <div class="pax-inputs">
    <b-row>
      <!-- TITULO DO CAMPO DOS INPUTS -->
      <b-col cols="12">
        <PmwHeading
          size="paragraph-60"
          weight="weight-normal"
          class="form--title"
        >
          {{ cardTitle }}
          <InfoTooltip
            :tooltipMinWidth="'335'"
            text="Valor à ser acrescido ao preço total, relativo à alimentação. O valor aqui informado não é opcional e será demonstrado ao hóspede já somado ao valor da diária."
          />
        </PmwHeading>
      </b-col>
    </b-row>

    <div class="form--row">
      <!-- INPUTS DE VALORES -->

      <!-- CAFÉ DA MANHÃ -->
      <PmwFormCurrencyInput
        v-model="boardData.valorCafe"
        :disabled="disableMealsInput"
        label="Café da manhã"
        type="number"
        placeholder=""
        suffix="BRL"
        class="form--input"
      />

      <!-- ALMOÇO -->
      <PmwFormCurrencyInput
        v-model="boardData.valorAlmoco"
        :disabled="disableMealsInput"
        label="Almoço"
        type="number"
        placeholder=""
        suffix="BRL"
        class="form--input"
      />

      <!-- JANTAR -->
      <PmwFormCurrencyInput
        v-model="boardData.valorJanta"
        :disabled="disableMealsInput"
        label="Jantar"
        type="number"
        placeholder=""
        suffix="BRL"
        class="form--input"
      />

      <!-- TOTAL -->
      <PmwFormCurrencyInput
        v-model="boardData.valorTotal"
        :disabled="disableTotal"
        label="TOTAL"
        type="number"
        placeholder=""
        suffix="BRL"
        class="form--input"
      />

      <!-- INPUTS DE SELECT -->

      <!-- LIMITE DE USO -->
      <PmwFormSelect
        v-if="boardData.valorTotal"
        :value="useLimitValue"
        :options="useLimitOptions"
        :search="true"
        :infoIcon="true"
        :required="boardData.valorTotal ? true : false"
        :error="errors.includes('Pensoes.LimiteUso')"
        data-error="Pensoes.LimiteUso"
        label="Limite de uso"
        infoText="Informe se a pensão cadastrada é diariamente ou uma Ceia específica para um dia."
        tooltipMinWidth="270"
        class="form--input__large"
        @input="selecLimitHandler"
      />

      <!-- DIAS FLEXÍVEIS -->
      <PmwFormField
        :infoIcon="true"
        label="Incluir nos dias flexíveis"
        infoText="Quando desejar, somaremos à flexibilização o valor da pensão cadastrada."
        tooltipMinWidth="270"
        class="form--input form--input__larger"
      >
        <div class="checkbox-wrapper">
          <InputCheckbox
            v-model="boardData.checkinFlexivel"
            :inputValue="true"
            :checked="boardData.checkinFlexivel"
            label="check-in"
            class="form--checkbox"
          />

          <InputCheckbox
            v-model="boardData.checkoutFlexivel"
            :inputValue="true"
            :checked="boardData.checkoutFlexivel"
            label="check-out"
            class="form--checkbox"
          />
        </div>
      </PmwFormField>
    </div>
  </div>
</template>

<script>
import PmwFormCurrencyInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormCurrencyInput'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwFormField from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormField'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'

export default {
  name: 'PensionByAgeInputs',
  components: {
    PmwFormCurrencyInput,
    PmwHeading,
    InfoTooltip,
    PmwFormSelect,
    PmwFormField,
    InputCheckbox
  },

  props: {
    boardData: {
      type: Object
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      totalFilled: false,

      useLimitOptions: [
        {
          text: 'Apenas 1x',
          value: 1
        },

        {
          text: 'Todos os dias da hospedagem',
          value: 2
        }
      ]
    }
  },

  computed: {
    cardTitle() {
      if (this.boardData.tipoPax === 10) return 'Pensão por adultos'

      return `Pensão por crianças (${this.boardData.idadeMinimaPax} - ${this.boardData.idadeMaximaPax} anos)`
    },

    /** Desabilita os inputs individuais se o total for preenchido  */
    disableMealsInput() {
      const { valorTotal, valorCafe, valorAlmoco, valorJanta } = this.boardData
      return Boolean(valorTotal) && !valorCafe && !valorAlmoco && !valorJanta
    },

    /** Desabilita o input de total se algum valor individual estiver preenchido */
    disableTotal() {
      const { valorCafe, valorAlmoco, valorJanta } = this.boardData
      return Boolean(valorCafe || valorAlmoco || valorJanta)
    },

    useLimitValue() {
      if (!this.boardData.limiteUso) {
        return this.useLimitOptions[1]
      }

      return this.useLimitOptions.find(
        (item) => +item.value === +this.boardData.limiteUso
      )
    }
  },

  watch: {
    'boardData.valorCafe'(newValue) {
      if (!newValue) {
        newValue = null
      }

      this.totalWatcherHandler(newValue)
    },

    'boardData.valorAlmoco'(newValue) {
      if (!newValue) {
        newValue = null
      }

      this.totalWatcherHandler(newValue)
    },

    'boardData.valorJanta'(newValue) {
      if (!newValue) {
        newValue = null
      }

      this.totalWatcherHandler(newValue)
    },

    'boardData.valorTotal'(newValue) {
      if (!newValue) {
        newValue = null
      }

      if (newValue) {
        this.boardData.limiteUso = this.useLimitValue.value
      }
    }
  },

  methods: {
    /** Calcula o Total com base nos campos individuais (Café da manhã, Almoço, Jantar) */
    mealsTotalSum() {
      let { valorCafe, valorAlmoco, valorJanta } = this.boardData

      !valorCafe ? (valorCafe = null) : null
      !valorAlmoco ? (valorAlmoco = null) : null
      !valorJanta ? (valorJanta = null) : null

      return valorCafe + valorAlmoco + valorJanta
    },

    verifyTotalSum() {
      const { valorCafe, valorAlmoco, valorJanta, valorTotal } = this.boardData

      if (!valorCafe && !valorAlmoco && !valorJanta && valorTotal) {
        this.boardData.valorTotal = null
      }
    },

    selecLimitHandler($event) {
      const { value } = $event
      this.boardData.limiteUso = +value
    },

    /** Método executado no watcher dos valores */
    totalWatcherHandler() {
      this.boardData.valorTotal = this.mealsTotalSum()

      this.verifyTotalSum()
    }
  }
}
</script>

<style scoped lang="scss">
.pax-inputs {
  & + & {
    margin-top: pmw-space(6);
  }

  ::v-deep {
    .pmw-select-options {
      width: auto;
      min-width: 100%;
    }
  }

  .form {
    &--title {
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-normal');
      line-height: 21px;
    }

    &--row {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 24px;
      margin-bottom: 18px;
    }

    &--input {
      width: 95px;

      &__large {
        width: 175px;

        ::v-deep {
          .pmw-select--button__caret-sort-up,
          .pmw-select--button__show {
            border-bottom-color: pmw-colors('blue-100');
          }
          .pmw-select--button:focus {
            border-color: pmw-colors('blue-100');
            border-bottom-color: pmw-colors('blue-100');
          }
          .pmw-select-options--item__hover:hover,
          .pmw-select-options--item__checked {
            background-color: pmw-colors('blue-100') !important;
          }

          .pmw-label {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .pmw-form-field--label {
            font-weight: font-weight('weight-medium');
          }
        }
      }

      &__larger {
        width: 300px;
      }

      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }
    }

    &--checkbox {
      width: 100px;
      flex: 0 1 auto;
    }
  }

  .checkbox-wrapper {
    margin-top: 12px;
    display: flex;
    gap: pmw-space(2);
    justify-content: flex-start;
  }
}
</style>
